import React from "react";
import "../../pages/templeTrustees/templetrustees.css";
import { Table } from "react-bootstrap";
import { Link } from "react-router-dom";
import useHotels from "./customHooks";
import { Container, Grid } from "@mui/material";

function Hotels() {
  const { data } = useHotels();
  return (
    <>
      <Container maxWidth={'xl'} className="page-header py-4 breadcrumb-bg">
        <h1 className="text-center display-6 breadcrumb-h1">Hotels</h1>
        <ul className="breadcrumb justify-content-center mb-0">
          <li className="breadcrumb-item">
            <Link to="/">Home</Link>
          </li>
          <li className="breadcrumb-item">
            <Link to="/">Visit Info</Link>
          </li>
          <li className="breadcrumb-item active">Hotels</li>
        </ul>
      </Container>

      <Container className="py-5">
        <Grid className="text-center mb-5">
          <h6 className="section-title text-center text-primary text-uppercase title-tl">
            Temple
          </h6>
          <h1 className="mb-3">
            <span className="text-secundary">Hotels</span>
          </h1>
        </Grid>

        <Grid container justifyContent={'center'}>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Table responsive striped className="trustee">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Phone Number</th>
                </tr>
              </thead>
              <tbody>
                {data.map((data, index) => (
                  <tr key={index}>
                    <td>{data.name}</td>
                    <td>{data.phone_number}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Grid>  
        </Grid>
      </Container>
    </>
  );
}

export default Hotels;
